<form [formGroup]="employeeForm" class="dialog-root">
  @if (data.employeeDto) {
    <h2 mat-dialog-title>{{ "employee.edit_employee" | transloco }}</h2>
  } @else {
    <h2 mat-dialog-title>{{"employee.add_employee" | transloco}}</h2>
  }


  <mat-dialog-content class="column-gap">
    <div class="row-gap">
      <mat-card>
        <mat-card-content class="image-selector">
          <div class="image-box">
            @if (imagePreview) {
              <img [src]="imagePreview" />
            }
          </div>
          <input #fileUpload (change)="selectFile($event)" accept="image/*" class="hidden" type="file" />
          <div class="row-gap-small">
            <button (click)="deleteImage()" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
            <button (click)="fileUpload.click()" mat-flat-button>{{ "label.add_image" | transloco }}</button>
          </div>
          @if (imageError) {
            <mat-error>{{ imageError }}</mat-error>
          }
        </mat-card-content>
      </mat-card>

      <mat-card class="flex">
        <mat-card-content class="column">
          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{ "form.label.first_name" | transloco}}</mat-label>
            <input formControlName="firstName" matInput type="text" />
          </mat-form-field>

          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{ "form.label.last_name" | transloco}}</mat-label>
            <input formControlName="lastName" matInput type="text" />
          </mat-form-field>

          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{"employee.external_id" | transloco}}</mat-label>
            <input formControlName="externalId" matInput type="text" />
          </mat-form-field>

          <mat-checkbox formControlName="canBook">{{"employee.can_book.description" | transloco}}</mat-checkbox>

          <div class="row-gap-small-center">
            <button (click)="restrictBookingTimes()" mat-icon-button>
              <mat-icon>edit</mat-icon>
            </button>
            @if (bookingConstraints.value.length > 0) {
              <p>{{ "label.booking_constraints.yes" | transloco}}</p>
            } @else {
              <p>{{ "label.booking_constraints.no" | transloco}}</p>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <mat-card>
      <mat-card-header class="row-space-between">
        <mat-card-title>{{ "form.label.category" | transloco }}</mat-card-title>
        <button [matMenuTriggerFor]="menu" mat-icon-button>
          <mat-icon>add_circle</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          @for (location of locations; track $index) {
            <button mat-menu-item [matMenuTriggerFor]="subMenu">
              @if(!location){
                <div>{{ "label.location.null" | transloco }}</div>
              }
              @else {
                <div>{{ location.name }}</div>
                <div class="small-text">{{ location.city }}, {{ location.street }}</div>
              }
            </button>

            <mat-menu #subMenu="matMenu">
              @for (category of getCategoriesByLocation(location?.locationId); track $index) {
                <button mat-menu-item (click)="addCategory(category.categoryId)">{{ category.name | localizedText }}
                </button>
              }
            </mat-menu>
          }
        </mat-menu>
      </mat-card-header>

      <mat-card-content class="margin-none">
        <mat-table #table [dataSource]="selectedCategoryDtos" class="width-none">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.name" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category"> {{ category.name | localizedText }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="location">
            <mat-header-cell *matHeaderCellDef>{{ "form.label.location" | transloco }}</mat-header-cell>
            <mat-cell *matCellDef="let category">{{ showLocationNameById(category.locationId) }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let category; let i = index" class="row-end">
              <button (click)="deleteCategory(i)" mat-icon-button>
                <mat-icon>delete</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="['name','location','delete']"></mat-header-row>
          <mat-row *matRowDef="let myRowData; columns: ['name','location','delete']"></mat-row>
        </mat-table>
      </mat-card-content>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>

    @if (data.employeeDto) {
      <button mat-flat-button (click)="updateEmployee()">{{ "button.save" | transloco }}</button>
    } @else {
      <button mat-flat-button (click)="createEmployee()">{{ "employee.add_employee" | transloco }}</button>
    }

  </mat-dialog-actions>
</form>
